import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";
import { Tab } from "~/components/seo/common";

interface ICollectionPageSeoProps {
  collectionName: string;
  tab: Tab | string;
}

export default function CollectionPageSeo({ collectionName, tab }: ICollectionPageSeoProps) {
  return (
    <SeoHead
      title={getCollectionFormattedTitle(collectionName, tab)}
      description={getCollectionFormattedDescription(collectionName, tab)}
    />
  );
}

function getCollectionFormattedTitle(collectionName: string, tab: Tab | string) {
  const intl = useIntl();

  switch (tab) {
    case "projects":
      return intl.formatMessage(
        { defaultMessage: '{collectionName} Projects – Govlaunch Collections', id: 'U+HNu8' },
        { collectionName: collectionName },
      );
    case "products":
      return intl.formatMessage(
        { defaultMessage: '{collectionName} Products – Govlaunch Collections', id: 'yZTSH0' },
        { collectionName: collectionName },
      );
    case "stories":
      return intl.formatMessage(
        { defaultMessage: '{collectionName} Stories – Govlaunch Collections', id: 'oa2489' },
        { collectionName: collectionName },
      );
    case "discussions":
      return intl.formatMessage(
        { defaultMessage: '{collectionName} Discussions – Govlaunch Collections', id: '1AgDSY' },
        { collectionName: collectionName },
      );
    default:
      return intl.formatMessage(
        { defaultMessage: '{collectionName} – Local Government Innovation Collections', id: 'f0IX9R' },
        { collectionName: collectionName },
      );
  }
}

function getCollectionFormattedDescription(collectionName: string, tab: Tab | string) {
  const intl = useIntl();

  switch (tab) {
    case "projects":
      return intl.formatMessage(
        { defaultMessage: 'Search the {collectionName} Collection for local government innovation projects.', id: 'PQYXpN' },
        { collectionName: collectionName },
      );
    case "products":
      return intl.formatMessage(
        { defaultMessage: 'Search the {collectionName} Collection for local government technology products.', id: 'HdEA0C' },
        { collectionName: collectionName },
      );
    case "stories":
      return intl.formatMessage(
        { defaultMessage: 'Search the {collectionName} Collection for local government innovation stories.', id: '7Zblun' },
        { collectionName: collectionName },
      );

    default:
      return intl.formatMessage(
        {
          defaultMessage: 'Search the {collectionName} Collection on Govlaunch. Discover {collectionName} projects, products and more.', id: 'rWiKjt',
        },
        { collectionName: collectionName },
      );
  }
}
